import { ApiPutRequest } from './api-put-request';
import { ApiParameters } from './api-parameters';
import { BankAccount } from '../../interfaces/bank-account';

export class AuthenticatedBsPaymentRequest extends ApiPutRequest
{
    public constructor(
        orderId: number,
        bankAccount: BankAccount,
        webapiBasepath: string
    )
    {
        super(  'AuthenticatedBsSale', 
                new ApiParameters(), 
                null, 
                {
                    orderId,
                    bankAccount
                },
                webapiBasepath
            );
    }
}
